<template>
	<div>
		<div class="banner" :class="title == '服务内容'?'bg1':'bg2'">
			<div class="banner-txt">
				<p>{{title}}</p>
				<p>{{tipTxt}}</p>
			</div>
			<div class="bread">
				<div class="bread-t">
					<span @click="goTo('/index')">首页 </span>/ <span @click="title == '服务内容'?goTo('/service'):goTo('/about')">{{title}}</span> {{breadTxt?'/ ' + breadTxt:''}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		props:{
			title:{
				type:String,
				default:'服务内容'
			},
			tipTxt:{
				type:String,
				default:'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'
			},
			breadTxt: {
				type:String,
				default: ''
			},
			bgUrl:{
				type:String,
				default: '../assets/img/service/service.png'
			}
		},
		methods:{
			goTo(path) {
				this.$router.push({
					path: path
				})
			},
		}
	}
</script>

<style>
.banner{
	width: 100%;
	height: 520px;
	margin-top: 80px;
	position: relative;
}
.bg1{
	background: url('../assets/img/service/service.png') no-repeat center center;
	background-size: 100% 100%;
}
.bg2{
	background: url('../assets/img/aboutht.png') no-repeat center center;
	background-size: 100% 100%;
}
.banner .banner-txt{
	width: 100%;
	height: calc(100% - 62px);
	padding-left:360px;
	font-size: 48px;
	color: #fff;
	z-index: 99;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.bread{
	width: 100%;
	position: absolute;
	bottom: 0;
	height: 62px;
	padding: 0 240px;
	line-height: 62px;
	background: rgba(0,0,0,0.5);
}
.bread-t{
	width: 100%;
	color: #fff;
}
.bread-t span{
	cursor: pointer;
}
.banner-txt>p:first-child{
	margin-bottom: 48px;
}
.banner-txt>p:last-child{
	font-size: 20px;
}
</style>